import Resource from '@/api/core/resource'

class ObraSocial extends Resource {
  constructor () {
    super('administracion/obras-sociales')
  }

  guardarDelegacion (obraSocialId, data) {
    return this.request.put(
      this.uri
        .concat('/')
        .concat(obraSocialId)
        .concat('/delegaciones'),
      data
    )
  }

  obtenerDelegaciones (obraSocialId, filtros) {
    return this.request.post(
      this.uri
        .concat('/')
        .concat(obraSocialId)
        .concat('/delegaciones/filtrar'),
      filtros
    )
  }

  eliminarDelegacion (obraSocialId, delegacionId) {
    return this.request.delete(
      this.uri
        .concat('/')
        .concat(obraSocialId)
        .concat('/delegaciones/')
        .concat(delegacionId)
    )
  }
}

export default new ObraSocial()
